import * as React from 'react';
import { SVGIconRender } from './SVGIconRender';

interface IconProps {
  color?: string;
  size?: string;
  bgFillColor?: string;
}

const SalesInboxModule = ({ color = 'black', bgFillColor = 'black', size = 'md' }: IconProps) => {
  return (
    <SVGIconRender
          size={size}
          color={color}
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M17 3C17.5523 3 18 3.44772 18 4C18 4.55228 17.5523 5 17 5C16.4477 5 16 5.44772 16 6V8V9H15H14V8V4V3H17ZM13 4H9C5.68629 4 3 6.68629 3 10V15C3 16.1046 3.89543 17 5 17H13V19H17V17H19C20.1046 17 21 16.1046 21 15V6C21 4.89543 20.1046 4 19 4V5C19 5.55228 18.5523 6 18 6H17V9C17 9.55228 16.5523 10 16 10H14C13.4477 10 13 9.55228 13 9V4Z"
            fill="url(#paint0_linear_123_14389)"
          />
          <path
            opacity="0.6"
            d="M4.63635 9.6671C4.63635 8.03546 6.13857 6.81778 7.73489 7.15546C8.68434 7.35631 9.36363 8.19432 9.36363 9.16478V14.182C9.36363 14.6339 8.99731 15.0002 8.54544 15.0002H5.45453C5.00266 15.0002 4.63635 14.6339 4.63635 14.182V9.6671Z"
            fill="#4F0501"
          />
          <defs>
            <linearGradient
              id="paint0_linear_123_14389"
              x1="12"
              y1="7"
              x2="12"
              y2="19"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#FB7870" />
              <stop offset="1" stop-color="#EC68FF" />
            </linearGradient>
          </defs>
        </SVGIconRender>
  );
};

export default SalesInboxModule;
